// Vendor libraries
import { CommonModule } from '@angular/common';
// Modules
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class GuidedWorkflowsMenuModule {
}
GuidedWorkflowsMenuModule.ɵfac = function GuidedWorkflowsMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsMenuModule)(); };
GuidedWorkflowsMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GuidedWorkflowsMenuModule });
GuidedWorkflowsMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, IconModule, TooltipModule] });
